/** @param {string} shareId */
export function loomEmbedUrl(shareId) {
  return `https://www.loom.com/embed/${shareId}`;
}

/** @param {string} input Share or embed URL */
export function parseLoomShareId(input) {
  const value = String(input || "").trim();
  const match = value.match(/loom\.com\/(?:share|embed)\/([a-zA-Z0-9]+)/);
  return match?.[1] || "";
}
